<template>
  <v-container>
    <v-row
      style="display: flex; flex-direction: column"
      @keydown.esc="cancel()"
    >
      <Header :items="items"
        ><template slot="title">
          {{ $tc("information.title") }}
        </template></Header
      >
      <v-col>
        <v-dialog v-model="showEdit" max-width="550px" persistent>
          <CardDialog>
            <template slot="title"> {{ $tc("information.editLiq") }} </template>
            <template slot="body">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-form ref="form" v-model="valid" lazy-validation class="mx-2">
                <v-text-field
                  disabled
                  v-model="data.nameLiq"
                  :label="$tc('information.liq')"
                />
                <v-text-field
                  class="mr-2"
                  disabled
                  v-model="data.nameConcept"
                  :label="$tc('information.concept')"
                />
                <v-text-field
                  disabled
                  v-model="data.nameCost"
                  :label="$tc('information.cost')"
                />
                <v-text-field
                  disabled
                  class="mr-2"
                  v-model="data.settledAmount"
                  :label="$tc('information.liqAmount')"
                />
                <div
                  v-if="data.licTot === 'N'"
                  style="display: flex; flex-direction: row"
                >
                  <v-menu
                    ref="menuAut"
                    v-model="menuAut"
                    offset-y
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="data.authorizedAmount"
                        :label="$tc('information.authorizedAmount')"
                        rounded
                        filled
                        v-bind="attrs"
                        v-on="on"
                        style="max-width: 200px"
                        class="ml-5"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="data.authorizedAmount"
                      class="mt-4"
                      scrollable
                      format="24hr"
                      :max="data.settledAmount"
                    >
                      <v-btn
                        text
                        color="primary"
                        @click="menuAut = false"
                        class="v-picker__actions"
                      >
                        Aceptar
                      </v-btn>
                    </v-time-picker>
                  </v-menu>

                  <v-menu
                    ref="menuNo"
                    v-model="menuNo"
                    offset-y
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="data.unauthorizedAmount"
                        :label="$tc('information.unauthorizedAmount')"
                        rounded
                        filled
                        v-bind="attrs"
                        v-on="on"
                        style="max-width: 200px"
                        class="ml-5"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="data.unauthorizedAmount"
                      class="mt-4"
                      scrollable
                      format="24hr"
                      :max="data.settledAmount"
                    >
                      <v-btn
                        text
                        color="primary"
                        @click="menuNo = false"
                        class="v-picker__actions"
                      >
                        Aceptar
                      </v-btn>
                    </v-time-picker>
                  </v-menu>
                </div>
                <div
                  v-else
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                  "
                >
                  <span class="switch__auto">{{
                    $tc("information.authorized")
                  }}</span>
                  <v-switch v-model="switchAuto" inset />
                  <span class="switch__auto">{{
                    $tc("information.unauthorized")
                  }}</span>
                  <v-switch v-model="switchNoAuto" inset />
                </div>
              </v-form>
              <div class="d-flex justify-space-between mx-2 mt-2 mb-n2">
                <v-btn class="bt-exit" @click="cancel()"
                  >{{ $tc("editRegistrations.cancel") }}
                </v-btn>
                <v-btn class="bt-acept" @click.prevent="hoursOrDay">
                  {{ $tc("editRegistrations.acept") }}</v-btn
                >
              </div>
            </template>
          </CardDialog>
        </v-dialog>

        <v-data-table
          :items="getResults"
          :headers="header"
          class="elevation-3 mt-5 mx-4"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <div class="center">
                    <v-icon
                      small
                      color="accent"
                      class="ml-4"
                      @click="openEdit(item)"
                      :disabled="signed"
                    >
                      fa-pen
                    </v-icon>
                  </div>
                </span>
              </template>
              <span>{{ $tc("editRegistrations.edit") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="withdrawSignature" max-width="480px">
      <CardDialog>
        <template slot="title">
          {{ $tc("information.continueTofirm") }}
        </template>
        <template slot="body">
          <h3 style="text-align: center">
            {{ $tc("information.wishToContinue") }}
          </h3>
        </template>

        <template slot="actions">
          <v-btn class="bt-exit" @click="withdrawSignature = false"
            >{{ $tc("editRegistrations.cancel") }}
          </v-btn>
          <v-btn class="bt-acept" @click="withdrawFirm">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </template>
      </CardDialog>
    </v-dialog>
    <v-snackbar v-model="alertOk" color="#909DFA" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="alertOk = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="alertError" color="#FF8D58" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="alertError = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Header from "./common/Header.vue";
import signNovelty from "../../../store/gestionTiempos/signNovelty";
import resultSettlementHours from "../../../store/gestionTiempos/resultSettlementHours";
import CardDialog from "./common/CardDialog.vue";
export default {
  components: { Header, CardDialog },
  props: {
    items: Object,
  },
  data() {
    return {
      menuNo: false,
      menuAut: false,
      title: this.$tc("information.resultSettlement"),
      switchAuto: null,
      switchNoAuto: null,
      showEdit: false,
      alertError: false,
      alertOk: false,
      textAlert: "",
      error: false,
      withdrawSignature: false,
      alertValidate: "",
      valid: true,
      timeAuto: false,
      data: {
        nameCost: "",
        nameLiq: "",
        nameConcept: "",
        unauthorizedAmount: 0,
        authorizedAmount: 0,
        settledAmount: 0,
        licTot: null,
      },
      authorizedAmount: null,
      unauthorizedAmount: null,
      settledAmount: null,
      header: [
        // {
        //     text: "Liquidación",
        //     value: "nameLiq",
        //     class: "primary secondary--text",
        //     sortable: true,
        //     align: "center"
        //   },
        {
          text: "Concepto",
          value: "namConcept",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Centro de Costo",
          value: "nameCost",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Cantidad Liquidada",
          value: "settledAmount",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Cantidad Autorizada",
          value: "authorizedAmount",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Cantidad No autorizada",
          value: "unauthorizedAmount",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
        },
      ],
    };
  },
  computed: {
    signed() {
      return this.$store.state.gestionTiempos.signed;
    },
    getResults() {
      return resultSettlementHours.state.settlementHours;
    },
  },

  methods: {
    //se abre el formulario de edicion
    async openEdit(item) {
      setTimeout(() => {
        this.showEdit = true;
      }, 5000);

      if (item.licTot === "S") {
        if (item.authorizedAmount === 1) {
          this.switchAuto = true;
        } else {
          this.switchAuto = false;
        }
        if (item.unauthorizedAmount === 1) {
          this.switchNoAuto = true;
        } else {
          this.switchNoAuto = false;
        }
      }

      this.data = {
        nameCost: item.nameCost,
        nameLiq: item.nameLiq,
        nameConcept: item.namConcept,
        unauthorizedAmount: item.unauthorizedAmount,
        authorizedAmount: item.authorizedAmount,
        settledAmount: item.settledAmount,
        conceptId: item.conceptId,
        csCostoId: item.csCostoId,
        liqId: item.liqId,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        licTot: item.licTot,
      };
    },
    // se cambia la hora por valores
    changeHourForValue(value) {
      let hoursAuto = value.slice(0, 2);
      let minAuto = value.slice(3, 5);
      const hourValue = 60;
      return parseFloat(hoursAuto * hourValue) + parseFloat(minAuto);
    },
    // se ve si es una hora o un dia
    hoursOrDay() {
      if (this.data.licTot === "N") {
        this.authorizedAmount = this.changeHourForValue(
          this.data.authorizedAmount
        );
        this.unauthorizedAmount = this.changeHourForValue(
          this.data.unauthorizedAmount
        );
        this.settledAmount = this.changeHourForValue(this.data.settledAmount);
        this.validateHours();
      } else {
        this.settledAmount = this.data.settledAmount;

        if (this.switchAuto) {
          this.authorizedAmount = 1;
        } else {
          this.authorizedAmount = 0;
        }
        if (this.switchNoAuto) {
          this.unauthorizedAmount = 1;
        } else {
          this.unauthorizedAmount = 0;
        }

        this.validateDays();
      }
    },

    //se valida el dia
    validateDays() {
      let limit = this.unauthorizedAmount + this.authorizedAmount;
      if (this.items.firm !== null) {
        this.withdrawSignature = true;
        this.error = true;
        this.alertValidate = this.$tc("information.changeFirm");
        setTimeout(() => {
          this.error = false;
        }, 3000);
      } else if (limit > this.settledAmount) {
        this.error = true;
        this.alertValidate = this.$tc("information.exceedsLimit");
        setTimeout(() => {
          this.error = false;
        }, 3000);
      } else {
        this.settlement();
      }
    },
    //se valida la hora
    validateHours() {
      let limit =
        parseFloat(this.authorizedAmount) + parseFloat(this.unauthorizedAmount);
      const valid = this.$refs.form.validate();
      if (valid) {
        if (limit > this.settledAmount) {
          this.error = true;
          this.alertValidate = this.$tc("information.exceedsLimit");
          setTimeout(() => {
            this.error = false;
          }, 3000);
        } else if (this.items.firm !== null) {
          this.withdrawSignature = true;
          this.error = true;
          this.alertValidate = this.$tc("information.changeFirm");
          setTimeout(() => {
            this.error = false;
          }, 3000);
        } else {
          this.settlement();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("information.changeGreater");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    //se edita
    settlement() {
      let payload = {
        authorizedAmount: this.authorizedAmount,
        conceptId: this.data.conceptId,
        csCostoId: this.data.csCostoId,
        date: this.data.date,
        liqId: this.data.liqId,
        nameConcept: this.data.nameConcept,
        nameCost: this.data.nameCost,
        nameLiq: this.data.nameLiq,
        settledAmount: this.settledAmount,
        unauthorizedAmount: this.unauthorizedAmount,
      };

      resultSettlementHours.commit("setEdit", payload);
      resultSettlementHours
        .dispatch("edit")
        .then((r) => {
          this.textAlert = "Se edito correctamente";
          this.alertOk = true;
          setTimeout(() => {
            resultSettlementHours.dispatch("getResults");
          }, 1200);
        })
        .catch((e) => {
          this.textAlert = e.response.data.error.message;
          this.alertError = true;
        });

      this.showEdit = false;
    },
    //se cancela el formulario
    cancel() {
      this.showEdit = false;
      this.error = false;
      this.$refs.form.resetValidation();
    },
    // se valida si tiene firmado el dia
    async withdrawFirm() {
      let payload = {
        empId: this.items.empId,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        flag: true,
      };
      signNovelty.commit("setNotFirm", payload);
      await signNovelty.dispatch("notFirmNovelty").then((r) => {
        setTimeout(() => {
          this.settlement();
        }, 1500);
        this.withdrawSignature = false;
      });
    },
  },
};
</script>

<style scoped>
.card-info {
  border: 3px double #a0caff;
  width: 600px;
  box-shadow: -4px 8px 22px -1px rgba(0, 0, 0, 0.75) !important;
  -webkit-box-shadow: -4px 8px 22px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -4px 8px 22px -1px rgba(0, 0, 0, 0.75);
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.title {
  color: #39537a;
  font-weight: lighter !important;
  margin-bottom: 20px !important;
  text-shadow: 1px 1px #384b6d;
  text-align: center;
}

@media (min-width: 300px) and (max-width: 450px) {
  .days {
    display: grid !important;
    grid-template-columns: repeat(1, 1fr) !important;
  }

  .checks {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

.switch__auto {
  margin-top: 19px !important;
  margin-right: 20px !important;
}
.v-picker__actions {
  min-width: 100% !important;
  display: flex !important;
  justify-content: flex-end !important;
}
</style>
